import React from 'react'
import { connect } from 'react-redux'
import { MAP_LEGENDS } from '../../leaflet/colorRamps'

const LegendLayers = props => {
    const { layersDispatch, name } = props
    if (name !== layersDispatch.view) {
        return <></>
    }
    return (
        <div style={{
            padding: '10px',
            lineHeight: '1.5em',
            fontSize: '11px',
            color: 'black',
            backgroundColor: '#FFFFFF',
            borderRadius: '2px',
            border: '1px solid lightgrey'
        }}>
            <h4 style={{ margin: '0 0 8px 0' }}></h4>
            {MAP_LEGENDS[layersDispatch.view].map((item, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                    <i style={{
                        width: '18px',
                        height: '18px',
                        backgroundColor: item.color,
                        marginRight: '8px',
                        opacity: 0.8,
                        display: 'inline-block'
                    }}></i>
                    {item.label}
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = () => (
    dispatch => ({
        layersDispatch: dispatch.layers
    })
)

export default connect(mapStateToProps)(LegendLayers)
